<template>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" :disabled="pullRefreshDisabled">
      <van-list v-model="dataLoading" :finished="dataFinished"
        :finished-text="noPage ? '' : list.length ? '' : (dataLoading || refreshing) ? '加载中...' : '暂无数据'"
        @load="onLoad" :error.sync="dataError" error-text="请求失败，点击重新加载">
        <div v-if="!list.length && !dataLoading && !refreshing" class="empty" />
        <div v-for="(item, index) in list" :key="item[rowKey]">
          <slot name="item" :row="item" :index="index">
            请传入列表展示插槽
          </slot>
        </div>
      </van-list>
    </van-pull-refresh>
  </template>
  <script>
  import axios from '@/axios/axios';
  import { config } from '@/axios/config';
  
  export default {
    props: {
      formatData: {
        type: Function,
        default: null
      },
      apiConfig: {
        type: Object,
        default: () => ({})
      },
      params: {
        type: Object,
        default: () => ({})
      },
      customerKeys: {
        type: Object,
        default: () => ({})
      },
      rowKey: {
        type: String,
        default: 'id'
      },
      noPage: {
        type: Boolean,
        default: false
      },
      pullRefreshDisabled: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        refreshing: false,//下拉刷新的加载状态
        dataLoading: false,//列表数据加载状态
        dataFinished: false,//是否加载完成
        dataError: false,//是否加载失败
        total: 0,
        page: {
          pageNo: 0,
          pageSize: 10,
        },
        data: [],//列表数据
        requestSym: null,
      };
    },
    watch: {
      params: {
        handler() {
          this.onRefresh();
        },
        deep: true
      }
    },
    computed: {
      list() {
        if (this.formatData) {
          return this.formatData(this.data)
        }
        return this.data
      }
    },
    methods: {
      /**
       * 修改表格某条数据
       * @param {*} row 元数据
       * @param {*} key 数据的key值
       * @param {*} newVal 需要修改的新的值
       */
      changeOneData(row, newVal, key = 'id',) {
        const index = (this.data || []).findIndex(v => v[key] === row[key]);
        if (index || index === 0) {
          this.data.splice(index, 1, { ...this.data[index], ...newVal });
        }
      },
      getData(data) {
        const { url, method, headers } = this.apiConfig;
        if (!url) {
          console.error('请传入接口地址');
          return
        }
        console.log(config);
        return axios({
          url,
          method: method || 'post',
          headers: {
            Authorization: config.Authorization,
            ...headers,
          },
          data,
        });
      },
      onRefresh() {
        this.$set(this.page, 'pageNo', 0);
        this.$nextTick(() => {
          this.onLoad();
        })
      },
      onLoad() {
        const { pageNo, pageSize } = this.page;
        const { pageNoKey = 'pageNo', pageSizeKey = 'pageSize', totalKey = 'totalCount', listKey = 'list', codeKey = 'errcode', errmsgKey = 'errmsg' } = this.customerKeys;
        const param = {
          [pageNoKey]: pageNo + 1,
          [pageSizeKey]: pageSize,
          ...this.params,
        };
        if (param[pageNoKey] === 1 && this.data && this.data.length > 0) {
          this.$toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: "加载中",
          });
        }
        this.dataLoading = true;
        const symbol = this.requestSym = Symbol();
        this.getData(param)
          .then((r) => {
            if (this.requestSym !== symbol) {
              return
            }
            this.$toast.clear();
            if (r[codeKey] == 0) {
              this.dataError = false;
              let newData = this.data;
              if (this.noPage) {
                newData = r.data;
              } else {
                this.total = r.data[totalKey];
                  const apiData = r.data[listKey];
                  if (pageNo === 0) {
                    newData = apiData;
                  } else {
                    newData.push(...apiData);
                  }
                  this.dataFinished = newData.length >= this.total;
                  this.$set(this.page, "pageNo", param[pageNoKey]);
              }
              
              this.data = newData;
              this.$emit('handleDataList', this.data, r)
              this.dataLoading = false;
              this.refreshing = false;
            } else {
              this.dataLoading = false;
              this.refreshing = false;
              this.dataError = true;
              this.$toast(r[errmsgKey] || '加载失败，请稍后重试');
            }
          })
          .catch((e) => {
            console.log('error', e)
            this.dataLoading = false;
            this.refreshing = false;
            this.dataError = true;
            this.$toast.clear();
            this.$emit('error', e);
          });
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .empty {
    width: 117px;
    height: 99px;
    background: url("~@/assets/empty.png") no-repeat bottom;
    background-size: 100%;
    margin: auto;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    padding-top: 50px;
    // margin-top: 150px;
  }
  </style>
  